"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Row = _interopRequireDefault(require("@emcasa/ui-dom/components/Row"));

// We should create a Spinner component. It's the same Spinner from packages/image-upload/UploadTarget/styles.jsx
var LoaderDotsSVG = function LoaderDotsSVG() {
  return _react["default"].createElement("svg", {
    preserveAspectRatio: "xMidYMid",
    height: 18,
    viewBox: "6 40 88 20"
  }, _react["default"].createElement("circle", {
    cx: "84",
    cy: "50",
    r: "10",
    fill: "#c0c2cc"
  }, _react["default"].createElement("animate", {
    attributeName: "r",
    repeatCount: "indefinite",
    dur: "0.625s",
    calcMode: "spline",
    keyTimes: "0;1",
    values: "5;0",
    keySplines: "0 0.5 0.5 1",
    begin: "0s"
  }), _react["default"].createElement("animate", {
    attributeName: "fill",
    repeatCount: "indefinite",
    dur: "2.5s",
    calcMode: "discrete",
    keyTimes: "0;0.25;0.5;0.75;1",
    values: "#c0c2cc;#c0c2cc;#c0c2cc;#c0c2cc;#c0c2cc",
    begin: "0s"
  })), _react["default"].createElement("circle", {
    cx: "16",
    cy: "50",
    r: "10",
    fill: "#c0c2cc"
  }, _react["default"].createElement("animate", {
    attributeName: "r",
    repeatCount: "indefinite",
    dur: "2.5s",
    calcMode: "spline",
    keyTimes: "0;0.25;0.5;0.75;1",
    values: "0;0;5;5;5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "0s"
  }), _react["default"].createElement("animate", {
    attributeName: "cx",
    repeatCount: "indefinite",
    dur: "2.5s",
    calcMode: "spline",
    keyTimes: "0;0.25;0.5;0.75;1",
    values: "16;16;16;50;84",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "0s"
  })), _react["default"].createElement("circle", {
    cx: "50",
    cy: "50",
    r: "10",
    fill: "#c0c2cc"
  }, _react["default"].createElement("animate", {
    attributeName: "r",
    repeatCount: "indefinite",
    dur: "2.5s",
    calcMode: "spline",
    keyTimes: "0;0.25;0.5;0.75;1",
    values: "0;0;5;5;5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.625s"
  }), _react["default"].createElement("animate", {
    attributeName: "cx",
    repeatCount: "indefinite",
    dur: "2.5s",
    calcMode: "spline",
    keyTimes: "0;0.25;0.5;0.75;1",
    values: "16;16;16;50;84",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.625s"
  })), _react["default"].createElement("circle", {
    cx: "84",
    cy: "50",
    r: "10",
    fill: "#c0c2cc"
  }, _react["default"].createElement("animate", {
    attributeName: "r",
    repeatCount: "indefinite",
    dur: "2.5s",
    calcMode: "spline",
    keyTimes: "0;0.25;0.5;0.75;1",
    values: "0;0;5;5;5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-1.25s"
  }), _react["default"].createElement("animate", {
    attributeName: "cx",
    repeatCount: "indefinite",
    dur: "2.5s",
    calcMode: "spline",
    keyTimes: "0;0.25;0.5;0.75;1",
    values: "16;16;16;50;84",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-1.25s"
  })), _react["default"].createElement("circle", {
    cx: "16",
    cy: "50",
    r: "10",
    fill: "#c0c2cc"
  }, _react["default"].createElement("animate", {
    attributeName: "r",
    repeatCount: "indefinite",
    dur: "2.5s",
    calcMode: "spline",
    keyTimes: "0;0.25;0.5;0.75;1",
    values: "0;0;5;5;5",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-1.875s"
  }), _react["default"].createElement("animate", {
    attributeName: "cx",
    repeatCount: "indefinite",
    dur: "2.5s",
    calcMode: "spline",
    keyTimes: "0;0.25;0.5;0.75;1",
    values: "16;16;16;50;84",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-1.875s"
  })));
};

var Spinner = function Spinner() {
  return _react["default"].createElement(_Row["default"], {
    alignItems: "center",
    justifyContent: "center",
    p: 3
  }, _react["default"].createElement(LoaderDotsSVG, null));
};

var _default = Spinner;
exports["default"] = _default;